export default {"src":"/_next/static/media/arrow_right.cb6641f2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};